import { atom } from 'jotai';

interface FilesImportProgressListState {
  show: boolean;
}

const defaultFilesImportProgressListState: FilesImportProgressListState = {
  show: false,
};

export const filesImportProgressListAtom = atom(defaultFilesImportProgressListState);
